module.exports = __webpack_public_path__ + "static/tv110-3aaee20c0d0b026f0d5ea46414106700.svg";